import * as React from 'react';
import { MultiKeyValueComponent } from '../common/types';
import { SelectType, SelectCommonProps } from '../common/select/types';
import { SelectBaseComponent } from '../common/select/select-base-component';

/**
 * SelectMulti component let you choose more than one option from list of options.
 *
 * > Each selected option can be removed by click on cross.
 * > It supports common InputControlContext component.
 */
export interface SelectMultipleProps extends MultiKeyValueComponent<number | string>, SelectCommonProps {
  locale: string;
}

export class SelectMultiple extends React.Component<SelectMultipleProps> {
  public render() {
    return <SelectBaseComponent
      {...this.props}
      selectType={SelectType.multiple}
    />;
  }
}
